import { useEffect, useMemo } from "react";
import { useHistory } from "react-router";

import { LocalStorageService } from "shared/services";
import { ILocalStorageKey } from "shared/types";

import { BAND_PATHS } from "Bands/router";
import { useBandRoute } from "Bands/utils";
import { getCurrentUser } from "Auth/state";
import { useDispatch } from "react-redux";
import { useProfileContext } from "Auth/contexts";

export const Homepage = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { getPath } = useBandRoute();
  const { isAdmin, currentUser } = useProfileContext();

  // if user doesn't have user roles, refetch user
  useEffect(() => {
    if (!currentUser?.attributes.userRoles) {
      dispatch(getCurrentUser());
    }
  }, [dispatch, currentUser]);

  const lastBandId = useMemo(
    () => LocalStorageService.getItem(ILocalStorageKey.lastBand) as string,
    []
  );

  useEffect(() => {
    // if user doesn't have user roles, we don't have enough info yet
    if (!currentUser?.attributes.userRoles) return;

    if (isAdmin) {
      history.push(BAND_PATHS.ADMIN_DASHBOARD);
      return;
    }

    if (lastBandId) {
      history.replace(getPath(BAND_PATHS.BAND_CALENDAR, { bandId: lastBandId }));
    }

    history.replace(BAND_PATHS.CALENDAR);
  }, [history, lastBandId, getPath, currentUser, isAdmin]);

  return null;
};
